import React, { createContext, useState, useCallback, useEffect } from 'react';
import Toast from 'components/Additional/Toast/Toast';

export const ToastContext = createContext();

const ToastWrapperContext = ({ children }) => {
	const [toast, setToast] = useState({
		message: undefined,
		show: false,
		type: undefined,
		duration: null,
	});

	const showToast = useCallback((message, type, duration = 5000) => {
		setToast({
			message,
			show: true,
			type,
			duration: duration,
		});
	}, []);

	const hideToast = useCallback(() => {
		setToast((prev) => ({ ...prev, show: false }));
	}, []);

	useEffect(() => {
		if (toast.show && toast.duration) {
			const timer = setTimeout(() => {
				hideToast();
			}, toast.duration);

			return () => clearTimeout(timer);
		}
	}, [toast.show, toast.duration, hideToast]);

	return (
		<ToastContext.Provider value={{ showToast, hideToast }}>
			{children}
			{toast.show && (
				<Toast
					duration={toast.duration}
					message={toast.message}
					type={toast.type}
					onClose={hideToast}
				/>
			)}
		</ToastContext.Provider>
	);
};

export default ToastWrapperContext;
